<h3 class="file-name-container">
  <a href="javascript:void(0)" (click)="generatePdf()">
    {{documentName}}
    <span class="material-symbols-outlined">open_in_new</span>
  </a>
</h3>
